import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";


import {
  IconButton,
  List,
  Typography,
} from "@material-ui/core";

import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import InfoIcon from "@material-ui/icons/InfoOutlined";
import * as ROUTES from "~/src/constants/routes";

import {
  Flex,
  Container,
  Link,
} from "~/src/components/global";
import { ChatListItem } from "~/src/components/messages";

const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    alignItems: "center",
    background: theme.palette.background.paper,
    boxShadow: `0 1px ${fade(theme.palette.text.primary, 0.2)}`,
    padding: [[theme.spacing(1), 0]],
    height: 60,
  },
}));

export default function Header(props) {
  const { chat } = props;
  const classes = useStyles();

  return chat ? (
    <div className={classes.header}>
      <Container disableMargins size="sm">
        <Flex>
          <Flex.Item fill>
            <Flex spaceChildren justify="start">
              <Link href={ROUTES.MESSAGES}>
                <IconButton aria-label="information">
                  <ArrowBackIcon />
                </IconButton>
              </Link>
              <List>
                <ChatListItem
                  chat={chat}
                  inMessageHeader
                />
              </List>
            </Flex>
          </Flex.Item>
          <Link href="/messages/[id]/about" as={`/messages/${chat.id}/about`}>
            <IconButton aria-label="information">
              <InfoIcon />
            </IconButton>
          </Link>
        </Flex>
      </Container>
    </div>
  ) : (
    <div className={classes.header}>
      <Container disableMargins size="sm">
        <Flex>
          <Flex.Item fill>
            <Flex spaceChildren justify="start">
              <Link href={ROUTES.MESSAGES}>
                <IconButton aria-label="information">
                  <ArrowBackIcon />
                </IconButton>
              </Link>
              <Typography>Loading message…</Typography>
            </Flex>
          </Flex.Item>
        </Flex>
      </Container>
    </div>
  );
}
